// Types
import type { APIProps } from '@/types/config/api'

// Configurations
import SystemConfig from '@/config/system'

const defaultAPIUrl = process.env.API_URL || 'https://api.rateup.ir/api'
const activeAPIUrl = SystemConfig.isActive && SystemConfig.apiUrl !== '' && SystemConfig.port > 0 ? SystemConfig.apiUrl : defaultAPIUrl

const APIConfig: APIProps = {
	url: activeAPIUrl,
	appUrl: process.env.API_APP_URL || '/api',
	version: process.env.API_VERSION || '1.0.0',
	cache: process.env.API_CACHE === 'true',
	batchFetchSize: 100,
	batchFetchSlugs: ['crm-service', 'crm-inventory-product', 'crm-customer', 'crm-service-category', 'crm-customer-category', 'crm-table'],
	revalidate: {
		article: 360,
		crm: {
			// is_confirmed
			business: 60,
			branch: 60,
			service: 60,
			serviceCategory: 60,
			option: 60,
			table: 60,
			inventoryProduct: 60,
			campaign: 60,
			reminder: 60,
			review: 60,
			template: 60,

			// Permissions
			admin: 120,

			// Order
			customerCategory: 120,
			courier: 120,
			orderProvider: 120,

			// Transactional: never cache live order data
			order: 10,

			// Near real-time: dashboards, logs, payments
			statistic: 60,
			cashboxLog: 60,
			inventoryLog: 60,
			transaction: 60,

			// Financial & stock: moderate freshness
			cashbox: 60,
			cashboxMovement: 60,
			inventory: 120,

			// General CRM entities: default tier
			backup: 120,
			blacklist: 120,
			businessDevice: 120,
			customer: 120,
			customerCredit: 120,
			developer: 120,
			discountCode: 120,
			field: 120,
			googleReview: 120,
			inventories: 120,
			inventoryBrand: 120,
			inventoryCategory: 120,
			inventoryPurchase: 120,
			inventorySupplier: 120,
			inventoryWarehouse: 120,
			orderChangeRequest: 120,
			packageSubscription: 120,
			provider: 120,
			smsSubscription: 120,

			// Reference data
			category: 86400,
			city: 86400,
			currency: 86400,
			deviceCategory: 86400,
			deviceModel: 86400,
			inventoryUnit: 86400,
			language: 86400,
			package: 86400,
			templateCategory: 86400
		},
		// Navigation: same on every business page
		menu: 3600,
		module: 360,
		token: 360,

		// User: same on every business page
		user: 60
	},
	canCreateBusiness: false,
	verificationTimer: 120,
	verificationNumber: 5
}

export default APIConfig
